import { useCallback, useEffect, useState } from 'react';

const sendHeight = (height: number) => {
  const payload = `${height}px`;

  window.parent.postMessage(
    {
      type: 'hcp:lead-capture-size',
      value: payload,
    },
    '*'
  );
};

export const useLeadCaptureHeight = () => {
  const [lastSentHeight, setLastSentHeight] = useState<number | null>(null);

  const updateHeight = useCallback(() => {
    const scrollHeight = document.getElementById('lead-capture-content')?.scrollHeight;
    if (!scrollHeight) {
      return;
    }

    if (lastSentHeight === null || Math.abs(scrollHeight - lastSentHeight) > 50) {
      sendHeight(scrollHeight);
      setLastSentHeight(scrollHeight);
    }
  }, [lastSentHeight, setLastSentHeight]);

  useEffect(() => {
    window.addEventListener('load', updateHeight);
    window.addEventListener('resize', updateHeight);

    return () => {
      window.removeEventListener('load', updateHeight);
      window.removeEventListener('resize', updateHeight);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return updateHeight;
};
